module.exports = __webpack_public_path__ + "c01146cf5375739311beeffb214a395d.png";